import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function planCustomizationDataFromQuery(query) {
  const planId = query.get('planId') ?? undefined;
  const planSlug = query.get('planSlug') ?? undefined;
  const checkoutFlowId = query.get('checkoutFlowId') ?? undefined;
  const isAddToCart = query.get('isAddToCart') === 'true' ? true : undefined;
  const {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    maxStartDate,
    minStartDate,
    biOptions,
    verticalStatusContent
  } = integrationDataFromQuery(query);
  const integrationData = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent
  };
  if (planId) {
    return {
      ...integrationData,
      planId,
      checkoutFlowId,
      isAddToCart,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...integrationData,
      planSlug,
      checkoutFlowId,
      isAddToCart,
      planId: undefined
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
export function planCustomizationDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  data.checkoutFlowId && query.set('checkoutFlowId', data.checkoutFlowId);
  data.isAddToCart && query.set('isAddToCart', 'true');
  return query;
}
//# sourceMappingURL=plan-customization-data.js.map